<template>
  <div class="plugin-wrap rec-items layout" v-if="config && Array.isArray(config.nodes)">
    <div class="rec-item__image-wrap" v-for="(node, index) in config.nodes" :key="index">
      <Xink :action="node.action">
        <img class="show-for-md" :src="node.src.pc" @load="onImgLoaded({
          src: node.src.pc,
          type: 'image',
          platform: 'desktop'
        })" />
        <img class="hide-for-md" :src="node.src.h5" @load="onImgLoaded({
          src: node.src.h5,
          type: 'image',
          platform: 'mobile'
        })" />
      </Xink>
    </div>
  </div>
</template>

<script>
import Xink from "@/components/Xink";

export default {
  name: 'MultiImageProductRecommend',
  components: { Xink },
  props: {
    config: { type: Object, required: true }
  },
  methods: {
    onImgLoaded(target) {
      this.$emit('load', target);
    }
  }
}
</script>

<style lang="scss" scoped>
  .rec-items {
    display: flex;
    .rec-item__image-wrap { flex: 1; }
  }
</style>